module.exports = __webpack_public_path__ + "img/addressimg.e158f5c3.jpg";